import api from "@/api/api";

export default class IdentityMonitoringService {
  static getMonitoringAlerts(context = null) {
    return api()
      .get(`/api/v1/monitor/alerts/?context=${context}`)
      .then((response) => response.data);
  }

  static getMonitoringAlert(id, context = null) {
    return api()
      .get(`/api/v1/monitor/alerts/${id}/?context=${context}`)
      .then((response) => response.data);
  }
}
